import {computed, ref} from 'vue';
import {useGetCompanyId} from '@common/utils';
import {clientSettingsEndpoints} from '@configuration';
import {defineStore, storeToRefs} from 'pinia';
import {useAuth} from '#imports';
import type {ClientCompanySettingsContextResource} from '@api';

export const useClientSettingsContextStore = defineStore('useClientSettingsContextStore', () => {
    const clientSettingsContext = ref<ClientCompanySettingsContextResource | null>(null);
    const companyId = useGetCompanyId();

    const loading = ref(false);
    const auth = useAuth();
    const {user} = storeToRefs(auth);

    async function fetchClientSettingsContext(currentCompanyId?: string): Promise<void> {
        try {
            if (!companyId && !currentCompanyId) return;
            const clientSettingsContextData = await clientSettingsEndpoints.getSettingsContext({companyId: currentCompanyId ?? companyId});

            if (clientSettingsContextData) {
                clientSettingsContext.value = clientSettingsContextData;
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }

    const isImmersionMode = computed(() => {
        return (
            user.value?.roles?.includes('ROLE_ADMIN') &&
            user.value?.identities.findIndex((identity) => {
                return identity.clientCompanyId === companyId;
            }) < 0
        );
    });

    return {
        fetchClientSettingsContext,
        clientSettingsContext,
        loading,
        isImmersionMode,
    };
});
